export const IDS = {
  PANEL: 'aurora-panel',
} as const;
